import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";

const ExportGains = ({ data }) => {
  if (!data) return null;

  return (
    <section className="bg-[#FFFAED] py-sp-100 sm:py-20">
      <div className="container px-3">
        <h2 className="text-darkBlack text-heading2 sm:text-2xl font-medium mb-12 sm:mb-10 text-center">
          {data.heading}
        </h2>
        <div className="flex flex-col gap-20 sm:gap-12">
          {data.items.map((item, index) => {
            const isEven = index % 2 === 0;
            return (
              <div
                key={item.id}
                className={`flex sm:flex-col items-center gap-16 sm:gap-6 max-w-[900px] mx-auto w-full ${
                  isEven ? "flex-row" : "flex-row-reverse"
                }`}
              >
                <div className="flex-1 w-full relative rounded-2xl overflow-hidden shrink-0">
                  <Image
                    src={IMAGES.exportInterest[item.imageKey]}
                    alt={item.title}
                    width={430}
                    height={250}
                    className="object-cover"
                  />
                </div>

                <div className="flex-1 w-full max-w-[480px] flex flex-col justify-center">
                  <h3 className="text-darkBlack text-2xl sm:text-xl font-medium mb-4">
                    {item.title}
                  </h3>
                  <div className="flex flex-col gap-3">
                    {item.points.map((point, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="shrink-0">
                          <circle cx="12" cy="12" r="10" fill="#4A9447" />
                          <path d="M8.5 12.5l2.5 2.5 5-5" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="text-darkBlack text-base font-medium sm:text-sm">
                          {point}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExportGains;
